/* eslint-disable no-alert */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Card, CardBody, CardTitle,
} from 'reactstrap';

import {
  Table, Tbody, Tr, Th, Td,
} from 'react-super-responsive-table';

import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

function DirectoryEntryCard(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { entity, t } = props;

  return (
    <>
      <Card>
        <CardBody>
          <CardTitle className="h4">{entity.name}</CardTitle>
          <Table className="table table-bordered mt-3">
            <Tbody>
              <Tr>
                <Th>{t('Email')}</Th>
                <Td>
                  {entity.email}
                </Td>
              </Tr>
              <Tr>
                <Th>{t('Company')}</Th>
                <Td>
                  {entity.company}
                </Td>
              </Tr>
              <Tr>
                <Th>{t('Phone')}</Th>
                <Td>
                  {entity.phone}
                </Td>
              </Tr>
              <Tr>
                <Td colSpan="2">
                  <h6>{t('Notes')}</h6>
                  {entity.notes}
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </CardBody>
      </Card>

      {entity.addresses.map((x) => (
        <Card key={x.id}>
          <CardBody>
            <CardTitle className="h4">{x.label}</CardTitle>
            <div className="float-end" style={{ width: '64px', height: '64px' }}>
              <span className="avatar-title rounded-circle bg-soft bg-success text-success font-size-24">
                <span className="mdi mdi-card-account-details-outline" />
              </span>
            </div>

            <address>
              <strong>{`${x.first_name} ${x.last_name}`}</strong>
              <br />
              <span>{x.address_line_1}</span>
              <br />
              {x.address_line_2 && (
                <>
                  <span>{x.address_line_2}</span>
                  <br />
                </>
              )}
              <span>{`${x.city} ${x.region} ${x.postcode}`}</span>
              <br />
              <span>{x.country_code}</span>

              <br />
              <br />
              <span>{x.company}</span>
              <br />
              <span>{x.email}</span>
              <br />
              <span>{x.phone}</span>
              <br />
            </address>
          </CardBody>
        </Card>
      ))}
    </>
  );
}

DirectoryEntryCard.defaultProps = {

};

DirectoryEntryCard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(DirectoryEntryCard));
